import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapFlagsSelectOption = React.lazy(function () { return import('../../bootstrap-components/components/BTFlagsSelect'); });
var bootStrapFlagsSelectOption = function (props) {
    return (React.createElement(BootStrapFlagsSelectOption, __assign({}, props)));
};
export var FlagsSelectOption = function (props) {
    var componentToDisplay;
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapFlagsSelectOption(props);
            break;
        default:
            componentToDisplay = bootStrapFlagsSelectOption(props);
            break;
    }
    return (React.createElement("div", null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
FlagsSelectOption.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light',
    searchable: true,
    disabled: false
};
//# sourceMappingURL=FlagsSelectOption.js.map